module.exports = __webpack_public_path__ + "img/oldIndex.6e4cbc87.png";